import "../../styles/blocks/project-page/project-text-block.scss";

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const ProjectTextBlock = ({ title, description, blockAlignment, titleTag = "h2" }) => {
	const TitleTag = titleTag;
	const alignmentModifier = {
		right: "project-text-block--right"
	}

	return (
		<section
			className={
				classNames('project-text-block', alignmentModifier[blockAlignment])
			}
		>
			<div className="project-text-block__wrapper container container--medium">
				<div className="project-text-block__content">
					<TitleTag className="project-text-block__title medium-title">
						{title}
					</TitleTag>

					<p className="project-text-block__description">
						{description}
					</p>
				</div>
			</div>
		</section>
	);
};

ProjectTextBlock.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	blockAlignment: PropTypes.string.isRequired,
	titleTag: PropTypes.oneOf(["h2", "h3"])
};

export default ProjectTextBlock;
